import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { Container } from "./styles";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const PaginatedItems = ({
  itemsPerPage,
  items,
  Items,
  forcePage,
  onPageChange,
}) => {
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = items.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(items.length / itemsPerPage);

  // Atualizar o itemOffset quando forcePage mudar
  useEffect(() => {
    if (forcePage !== undefined) {
      const newOffset = (forcePage * itemsPerPage) % Math.max(items.length, 1);
      setItemOffset(newOffset);
    }
  }, [forcePage, items.length, itemsPerPage]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % Math.max(items.length, 1);
    setItemOffset(newOffset);

    // Notificar o componente pai sobre a mudança de página
    if (onPageChange) {
      onPageChange(event.selected);
    }
  };

  return (
    <Container>
      <Items currentItems={currentItems} />
      <ReactPaginate
        className="pagination"
        breakLabel="..."
        nextLabel={<FaArrowRight />}
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel={<FaArrowLeft />}
        renderOnZeroPageCount={null}
        forcePage={forcePage}
      />
    </Container>
  );
};

export default PaginatedItems;
